export const ALPHABET = ["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z"];

/**
 * convert data from sheet choice to object
 */
 

export function convertData(arr) {
  const attributes = arr[0];
  const indexTemplate = {};

  attributes.forEach((attribute) => {
    indexTemplate[attribute] = null;
  });

  const data = {};

  arr.slice(1).forEach((item) => {
    const obj = {};
    item.forEach((value, index) => {
      obj[attributes[index]] = value;
    });

    if (!data[obj[attributes[0]]]) {
      data[obj[attributes[0]]] = [];
    }
    data[obj[attributes[0]]].push(Object.assign({}, indexTemplate, obj));
  });
  return data;
}


//convert data from array form to object
export function convertArray(arr, header) {
  const result = new Array(header.length).fill("");
  arr.forEach((item) => {
    const index = header.indexOf(item[0]);
    if (index !== -1) {
      result[index] = item[1];
    }
  });
  return result;
}

// delete item select
export function deleteItem(arr, item) {
  const keys = arr[0];
  const itemIndex = arr.findIndex(
    (el) => el[0] === item.list_name && el[1] === item.name
  );
  if (itemIndex !== -1) {
    arr.splice(itemIndex, 1);
    const newItem = {};
    keys.forEach((key, index) => {
      if (item[index]) {
        newItem[key] = item[index];
      } else {
        newItem[key] = null;
      }
    });
    return newItem;
  }
  return null;
}

// edit item select
export function editItem(arr, item, newEdit) {
  const itemIndex = arr.findIndex(
    (el) => el[0] === item.list_name && el[1] === item.name
  );
  if (itemIndex !== -1) {
    arr[itemIndex] = newEdit;
  }
  return null;
}

//style item rating box
export function getStyleRatingBox(appearances) {
  const itemStyle = {
    width: 100 + "%",
    height: 100 + "%",
    padding: "5px 15px",
    cursor: "pointer",
    minWidth: "unset",
  };

  let colorCode = appearances.match(/[0-9a-f]{6}/gi);
  let isFill = appearances.indexOf("-fill") >= 0;

  let unchecked = {};
  let checked = {};

  if (colorCode != null) {
    unchecked["boxShadow"] = "#" + colorCode[0] + " 0px 0px 0px 1px inset";
    unchecked["color"] = "#" + colorCode[2];
    checked["boxShadow"] = "#" + colorCode[1] + " 0px 0px 0px 1px inset";
    checked["color"] = "#" + colorCode[3];

    if (isFill) {
      unchecked["backgroundColor"] = "#" + colorCode[0];
      checked["backgroundColor"] = "#" + colorCode[1];
    }
  }else{
    unchecked["boxShadow"] = "var(--answer-color) 0px 0px 0px 1px inset";
    checked["boxShadow"] = "var(--answer-color) 0px 0px 0px 2px inset";
  }

  itemStyle.unchecked = {
    ...itemStyle,
    ...unchecked,
  };

  itemStyle.checked = {
    ...itemStyle,
    ...checked,
  };
  return itemStyle;
}
//style wrapper rating box
export function getWrapperStyleRatingBox(optionsCount, maxItems) {
  let colWidth = 100 / optionsCount;
  if (!maxItems) colWidth = colWidth < 20 ? 20 : colWidth;
  const wrapperStyle = {
    width: Math.floor(colWidth) + "%",
    flex: "0 0 " + Math.floor(colWidth) + "%",
    maxWidth: Math.floor(colWidth) + "%",
    padding: "0px 5px",
    marginBottom: "5px",
  };
  return wrapperStyle;
}
